module.exports = __webpack_public_path__ + "static/media/pod-action-alert.cfa918f9.svg";